import type { FunctionComponent } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import MediaQuery from 'react-responsive';
import { getImagesStaticUrl } from '../../../helpers';
import ReactivateTodayDisclaimer from '../ReactivateTodayDisclaimer';
import * as styles from './MainBanner.module.scss';

export const REACTIVATE_TITLE = 'Reactivate Your Membership';
export const REACTIVATE_DESCRIPTION =
  'Don’t miss out on fully customizing your seasonal box, access to members only sales, and other amazing membership perks.';

type MainBannerProps = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  setShowRetry: (showRetry: boolean) => void;
};

const MainBanner: FunctionComponent<MainBannerProps> = ({
  isLoading,
  setIsLoading,
  setShowRetry,
}) => {
  const { reactivateTodayHero } = useFlags();
  const getHeroImage = () => {
    if (!reactivateTodayHero) return getImagesStaticUrl('reactivate-today-box-2.jpg');

    return 'https://scontent01.fabfitfun.com/my-account/cdn/stacked-products-reactivate-today.jpg';
  };

  return (
    <section className={styles.todayMainBanner} data-testid="main-banner-container">
      <div className={styles.todayMainBanner__imageContainer}>
        <img src={getHeroImage()} alt="Open box" />
      </div>
      <div className={styles.todayMainBanner__titleContainer}>
        <h1 className={styles.todayMainBanner__title}>{REACTIVATE_TITLE}</h1>
        <p className={styles.todayMainBanner__description}>{REACTIVATE_DESCRIPTION}</p>
        <MediaQuery minDeviceWidth={768}>
          <ReactivateTodayDisclaimer
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setShowRetry={setShowRetry}
          />
        </MediaQuery>
      </div>
    </section>
  );
};

export default MainBanner;
